"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime/helpers/assertThisInitialized"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _memoizeFormElement = _interopRequireDefault(require("../../Utilities/memoizeFormElement"));

var _Form = require("../../Form");

var _Elements = require("../../Components/Elements");

var _Components = require("../../Components");

var _Validations = require("../../Validations");

var _Utilities = require("../../Utilities");

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { (0, _defineProperty2["default"])(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = (0, _getPrototypeOf2["default"])(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0, _getPrototypeOf2["default"])(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0, _possibleConstructorReturn2["default"])(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

var additionalComparisonProps = [];

var Checkbox = /*#__PURE__*/function (_React$PureComponent) {
  (0, _inherits2["default"])(Checkbox, _React$PureComponent);

  var _super = _createSuper(Checkbox);

  function Checkbox() {
    var _this;

    (0, _classCallCheck2["default"])(this, Checkbox);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "onChange", function (event) {
      event.preventDefault();

      _this.props.onChange({
        value: !_this.props.value,
        name: _this.props.name
      });
    });
    return _this;
  }

  (0, _createClass2["default"])(Checkbox, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      if (this.props.noRegister) additionalComparisonProps.push('errorId');
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;

      var _this$props = this.props,
          name = _this$props.name,
          id = _this$props.id,
          label = _this$props.label,
          subLabel = _this$props.subLabel,
          value = _this$props.value,
          validations = _this$props.validations,
          submitAttempted = _this$props.submitAttempted,
          isRequired = _this$props.isRequired,
          attr = _this$props.attr,
          center = _this$props.center,
          multipleValue = _this$props.multipleValue;
      var errorId = '';

      if (this.props.noRegister) {
        errorId = this.props.errorId || '';
      } else {
        errorId = (0, _Utilities.getFormErrorId)(validations, submitAttempted);
      }

      var sub = subLabel ? /*#__PURE__*/_react["default"].createElement(_Components.Label, {
        className: "sublabel",
        name: "".concat(name, "-sublabel"),
        id: "".concat(id, "-sublabel"),
        label: subLabel
      }) : null;
      return /*#__PURE__*/_react["default"].createElement(_Elements.CheckboxWrapper, {
        className: errorId ? 'form-error' : ''
      }, /*#__PURE__*/_react["default"].createElement("input", {
        type: "hidden",
        value: value,
        name: name,
        id: id
      }), /*#__PURE__*/_react["default"].createElement(_Elements.StyledCheckbox, (0, _extends2["default"])({
        tabIndex: 0,
        role: "checkbox",
        checked: value,
        error: errorId,
        "aria-checked": value,
        center: center && sub,
        onClick: this.onChange,
        multipleChecked: multipleValue,
        onKeyDown: function onKeyDown(e) {
          return (e === null || e === void 0 ? void 0 : e.key) === 'Enter' ? _this2.onChange(e) : null;
        }
      }, attr, {
        "aria-labelledby": "".concat(id, "-label"),
        "aria-invalid": errorId ? true : undefined,
        required: isRequired ? true : undefined,
        "aria-describedby": sub ? "".concat(id, "-sublabel") : undefined
      })), /*#__PURE__*/_react["default"].createElement("div", null, /*#__PURE__*/_react["default"].createElement(_Components.Label, {
        label: label,
        id: "".concat(id, "-label"),
        name: "".concat(name, "-label"),
        isRequired: isRequired,
        onClick: function onClick(e) {
          e.stopPropagation();

          _this2.onChange(e);
        }
      }), sub, /*#__PURE__*/_react["default"].createElement(_Components.ErrorMessage, {
        noSpacing: this.props.noSpacing,
        id: errorId
      })));
    }
  }]);
  return Checkbox;
}(_react["default"].PureComponent);

Checkbox.propTypes = {
  submitAttempted: _propTypes["default"].bool.isRequired,
  validations: _propTypes["default"].object,
  value: _propTypes["default"].bool,
  multipleValue: _propTypes["default"].bool,
  name: _propTypes["default"].string.isRequired,
  id: _propTypes["default"].string.isRequired,
  onChange: _propTypes["default"].func.isRequired,
  attr: _propTypes["default"].object,
  isRequired: _propTypes["default"].bool,
  label: _propTypes["default"].oneOfType([_propTypes["default"].string, _propTypes["default"].func, _propTypes["default"].node]).isRequired,
  subLabel: _propTypes["default"].string,
  initialValue: _propTypes["default"].bool,
  noRegister: _propTypes["default"].bool,
  noSpacing: _propTypes["default"].bool,
  errorId: _propTypes["default"].string,
  center: _propTypes["default"].bool
};
Checkbox.defaultProps = {
  attr: {},
  isRequired: false,
  validations: {},
  subLabel: '',
  initialValue: false,
  noRegister: false,
  center: false,
  multipleValue: false
};
Checkbox.Validations = {
  required: _objectSpread(_objectSpread({}, _Validations.required), {}, {
    emptyValue: false
  })
};
var MemoCheckbox = (0, _memoizeFormElement["default"])(Checkbox, additionalComparisonProps);

var _default = (0, _Form.asFormElement)(MemoCheckbox);

exports["default"] = _default;